export const SERVICE_CODE = 'SUBSIDIARY' + '_SERVICE';
